module.exports = __webpack_public_path__ + "static/kiosk_mobile-7f4646aaa3ca9a220547b85e8993a2fe.svg";